export default {
      id: "refresh-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#refresh-usage",
      toString: function () {
        return this.url;
      }
    }